import React from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';

const EccentricityTest: React.FC = () => {
  const { t } = useTranslation(['task']);
  const columns = [
    {
      dataIndex: 'col1',
      key: 'col1',
      render: (value: string) => (
        <div className="h-10 w-10 p-0 text-left text-sm font-semibold">{value}</div>
      ),
    },
    {
      dataIndex: 'col2',
      key: 'col2',
      render: (value: string) => (
        <div className="h-10 w-10 p-0 text-left text-sm font-semibold">{value}</div>
      ),
    },
    {
      dataIndex: 'col3',
      key: 'col3',
      render: (value: string) => (
        <div className="h-10 w-10 p-0 text-left text-sm font-semibold">{value}</div>
      ),
    },
  ];

  const dataSource = [
    { key: 'row1', col1: '5', col2: '', col3: '2' },
    { key: 'row2', col1: '', col2: '1', col3: '' },
    { key: 'row3', col1: '4', col2: '', col3: '3' },
  ];

  return (
    <div className="w-[350px]">
      <h1 className="m-2 ml-0">{t('eccentricityTest')}</h1>
      <Table
        className="[&_.ant-table-cell]:!p-2 [&_.ant-table-cell]:align-top"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered
        showHeader={false}
        rowHoverable={false}
      />
    </div>
  );
};

export default EccentricityTest;
